import { render } from "./Contabilidad.vue?vue&type=template&id=63084738&scoped=true"
import script from "./Contabilidad.vue?vue&type=script&lang=js"
export * from "./Contabilidad.vue?vue&type=script&lang=js"

import "./Contabilidad.vue?vue&type=style&index=0&id=63084738&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63084738"

export default script